import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import moment from 'moment'
import { get } from 'lodash'
import queryString from 'query-string'

import { Checkbox } from 'components/fields'
import { wizard } from 'helpers/decorators'
import { Title, Button, FormDebug } from 'components/misc'
import validate from './privacy-policy.validation'
import { apiNextLevel, apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS, PAYMENT_TYPES, AGE } from 'constants/enums'
import config from 'config'

@apiNextLevel()
@apiConfiguration()
@connect((state, props) => {
  const policyTextObj = get(
    props,
    `configuration.values[${CONFIGURATION_KEYS.privacyPolicyText.id}]`
  )

  return {
    hasPolicy: get(
      props,
      `configuration.values[${CONFIGURATION_KEYS.privacyPolicyCheck.id}].booleanValue`,
      false
    ),
    policyText: get(policyTextObj, 'translatedText') ||
      get(policyTextObj, 'textValue')
  }
})
@wizard({
  form: 'nextLevelRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate
})
class PrivacyPolicy extends Component {
  static propTypes = {
    reset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    createParticipant: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    hasPolicy: PropTypes.bool,
    policyText: PropTypes.string,
    onGetConfigurationValue: PropTypes.func,
    values: PropTypes.object
  }

  componentDidMount() {
    Promise.all([
      this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.privacyPolicyCheck.id,
        get(this.props.values, 'organizationId')
      ),
      this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.privacyPolicyText.id,
        get(this.props.values, 'organizationId')
      )
    ])
  }

  handleSubmit = fields => {
    const query = queryString.parse(get(this.props, 'location.search'))
    const authorizationCode = get(query, 'authorizationCode')
    const age = moment().diff(get(fields, 'birthDate'), 'years')
    const isAdultFlow =
      (get(fields, 'helpers.price') === PAYMENT_TYPES.online.id ||
        get(fields, 'helpers.price') === PAYMENT_TYPES.payPal.id ||
        get(fields, 'helpers.price') === PAYMENT_TYPES.globalPayments.id ||
        get(fields, 'helpers.price') === PAYMENT_TYPES.globalPaymentsWebpay.id) &&
      age >= AGE.adult

    this.props
      .createParticipant(authorizationCode, fields)
      .then(result => {
        const lastAwardIndex = get(result, 'body.awards', []).length - 1

        if (isAdultFlow) {
          const authCode = get(
            result,
            `body.awards[${lastAwardIndex}].participantRegistration.onlinePaymentAuthorizationCode`
          )

          const orgId = get(result, `body.awards[${lastAwardIndex}].organization.id`)

          this.props.reset()

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.online.id) {
            return this.props.push(`${config.publicPath}/mpg-init/` + authCode)
          }

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.payPal.id) {
            return this.props.push(`${config.publicPath}/paypal-init/` + authCode)
          }

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.globalPayments.id) {
            return this.props.push(`${config.publicPath}/gp-init/` + orgId + '/' + authCode)
          }

          if (get(fields, 'helpers.price') === PAYMENT_TYPES.globalPaymentsWebpay.id) {
            return this.props.push(`${config.publicPath}/gp-wp-init/${authCode}`)
          }
        }

        // // this.props.onSubmit()
        this.props.push(`${config.publicPath}/register/next-level/success`)
        this.props.reset()
      })
      .catch(err => console.debug(err))
  }

  render() {
    const { handleSubmit, hasPolicy, policyText } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.great_you_are_almost_there"
            defaultMessage="Great, you are almost there. Last step is Privacy Policy for new level"
          />
        </Title>
        <div className="row">
          <div className="col-xs-12">
            {hasPolicy &&
              <div>
                {policyText &&
                  <div
                    className="terms-box"
                    dangerouslySetInnerHTML={{ __html: policyText }}
                  />}
                <Checkbox
                  name="helpers.agreementPrivacyPolicy"
                  label="I have read the Privacy Policy and agree with them."
                  intlKey="label.i_have_read_privacy_policy"
                />
              </div>}

          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Checkbox
              name="helpers.terms"
              label="I have read the <a href='{url}' target='_blank'>Terms and conditions</a> and agree with them."
              intlKey="label.i_have_read_the_terms_and_conditions"
              intlValues={{
                url: '/orb_parental_consent_form.pdf'
              }}
            />
            <Checkbox
              name="helpers.photosConsent"
              label="You can use my photos for promotional purposes. We will always contact you before using your materials. For more information click here."
              intlKey="label.you_can_use_my_photos_for_promotional_purposes"
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="col-xs-12">
            {!hasPolicy &&
              <Note intlKey="label.no_privacy_policy">
                No privacy policy found. You can safely proceed by clicking
                finish button
              </Note>}
          </div>
        </div> */}
        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.finish" defaultMessage="Finish" />
        </Button>
      </form>
    )
  }
}

export default PrivacyPolicy
